import en from './en.json'
import it from './it.json'

export const supportTranslations = {
	en,
	it
} as const
